import { useEffect } from "react";
import "../styles/Cursor.css";

const Cursor = () => {
  useEffect(() => {
    const cursor = document.createElement("div");
    const dot = document.createElement("div");

    cursor.className = "custom-cursor";
    dot.className = "custom-cursor-dot";

    document.body.appendChild(cursor);
    document.body.appendChild(dot);

    const moveCursor = (e) => {
      // 🔥 SAFETY CHECK (prevents crash)
      if (!cursor || !dot) return;

      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;

      // Small delay for dot (smooth effect)
      setTimeout(() => {
        if (!dot) return;
        dot.style.left = `${e.clientX}px`;
        dot.style.top = `${e.clientY}px`;
      }, 20);
    };

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);

      // 🔥 Safe cleanup (prevents errors on route change)
      if (document.body.contains(cursor)) {
        document.body.removeChild(cursor);
      }
      if (document.body.contains(dot)) {
        document.body.removeChild(dot);
      }
    };
  }, []);

  return null;
};

export default Cursor;
